import { createContext, useContext } from 'react';
import { useStore } from 'zustand/react';
import type { ConversationFormDataType } from '@/components/conversations/conversation-form';
import type { ContentInteractionType } from '@/components/conversations/conversation-list/message-list-item/message-content/content-common-props';
import { type ConversationStoreType, createConversationStore } from '@/stores/conversation';

interface ConversationHandler {
  handleInteraction: (type: ContentInteractionType, position?: [number, number]) => void;
  handleSubmit: (data: ConversationFormDataType) => Promise<void>;
  handleCheckStatus: () => Promise<boolean>;
}

export const StoreContext = createContext<ConversationStoreType>(createConversationStore('session', 0));

export const HandlerContext = createContext<ConversationHandler>({
  handleInteraction: () => {},
  handleSubmit: () => Promise.reject(),
  handleCheckStatus: () => Promise.resolve(false),
});

export default function useConversationStore() {
  const store = useContext(StoreContext);

  return useStore(store);
}

export function useConversationHandlers() {
  return useContext(HandlerContext);
}
